<template>
  <component
    :is="component"
    v-if="component"
    class="dn-ticker"
    :investor-ticker="investorTicker"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const investorTicker = useRuntimeConfig()?.public?.config?.investorTicker;
const component = shallowRef(null);
if (investorTicker) {
  component.value = defineAsyncComponent(async () => {
    try {
      return await import(`~/components/${investorTicker.component}/${investorTicker.component}.vue`);
    } catch (e) {
      return null;
    }
  });
}
</script>

<style lang="scss">
.dn {
  &-ticker {
    --dn_font-family: var(--typography-utility-m-font-family);
    --dn_color: var(--color-investor-fg);

    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-investor-bg);
    width: 100%;
    z-index: 8;

    &::after {
      content: '';
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      width: 60px;
      height: 100%;
      background: linear-gradient(to right, transparent, var(--color-investor-bg));
      pointer-events: none;

      @media only screen and (width >= 1280px) {
        display: none;
      }
    }

    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      inline-size: min(var(--header-width, 1280px), 100vw - var(--site-padding, 1rem) * 2);
      overflow-x: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .item {
      display: flex;
      gap: 3px;
      text-decoration: none;

      &-content {
        display: flex;
        flex: 0 0 auto;
        justify-content: space-between;
        gap: var(--row-gap);
        font-variant-numeric: tabular-nums;
        padding: 7px 0;
      }

      &-holder {
        display: flex;
        gap: 8px;
      }

      &-difference {
        &-holder {
          display: flex;
          align-items: center;
          gap: 2px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
